import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Selectors from '../selectors';
import Actions from '../action';
import CommissionProfilesPresentational from './commission-profiles-presentational';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';

const CommissionProfilesFunctional = ({ userDetails, history, getCommissionProfile, commissionProfilesLoading, commissionProfilesData }) => {
	useEffect(() => {
		getCommissionProfile();
	}, []);

	return (
		<CommissionProfilesPresentational
			userDetails={userDetails}
			history={history}
			data={history.location.state}
			commissionProfilesLoading={commissionProfilesLoading}
			commissionProfilesData={commissionProfilesData}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: SelectorsApp.userDetails(state),
		commissionProfilesLoading: Selectors.commissionProfilesLoading(state),
		commissionProfilesData: Selectors.commissionProfilesData(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getCommissionProfile: () => dispatch(Actions.creators.getCommissionProfile()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(CommissionProfilesFunctional);

export default Connected;
